/**
 * True when `pathname` is one of the public prefixes or a child of one.
 *
 * Exact matching is deliberate: `/p` must not make `/pfoo` public. The base
 * href is stripped first so the check also works when the app is mounted
 * under a sub-path.
 */
export function isPublicPath(
  pathname: string,
  prefixes: readonly string[],
  baseHref = '/',
): boolean {
  const path = stripBaseHref(pathname, baseHref);

  return prefixes.some((prefix) => {
    const normalized = prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
    if (!normalized.startsWith('/')) return false;
    return path === normalized || path.startsWith(`${normalized}/`);
  });
}

function stripBaseHref(pathname: string, baseHref: string): string {
  const base = baseHref.endsWith('/') ? baseHref.slice(0, -1) : baseHref;
  if (base === '' || base === '/') return pathname;

  return pathname.startsWith(base)
    ? pathname.slice(base.length) || '/'
    : pathname;
}
